function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "global",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_18",
  "data-name": "Path 18",
  d: "M166.769,406.286v-7.775a28.293,28.293,0,0,0-5.711.8,21.676,21.676,0,0,0,.969,2.044C163.425,403.934,165.163,405.715,166.769,406.286Zm0,0",
  transform: "translate(-149.553 -370.043)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M275.742,401.359a21.644,21.644,0,0,0,.969-2.044,28.292,28.292,0,0,0-5.711-.8v7.775c1.607-.572,3.344-2.352,4.742-4.928Zm0,0",
  transform: "translate(-251.641 -370.044)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_20",
  "data-name": "Path 20",
  d: "M139.423,275.806v-7.13h-7.814a30.447,30.447,0,0,0,1.368,8.057,30.412,30.412,0,0,1,6.447-.926Zm0,0",
  transform: "translate(-122.207 -249.483)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M139.424,133.955v-7.13a30.43,30.43,0,0,1-6.447-.926,30.445,30.445,0,0,0-1.368,8.057Zm0,0",
  transform: "translate(-122.208 -116.905)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M335.643,14.535a22.911,22.911,0,0,0,3.675-1.6A18.328,18.328,0,0,0,332.234,8.8a17.622,17.622,0,0,1,2.251,3.277,24.342,24.342,0,0,1,1.158,2.461Zm0,0",
  transform: "translate(-308.501 -8.169)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M162.028,4.927a21.679,21.679,0,0,0-.969,2.044,28.294,28.294,0,0,0,5.711.8V0c-1.607.572-3.344,2.352-4.742,4.928Zm0,0",
  transform: "translate(-149.553)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M271,268.676v7.13a30.426,30.426,0,0,1,6.447.926,30.458,30.458,0,0,0,1.368-8.057Zm0,0",
  transform: "translate(-251.641 -249.483)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M271,126.825v7.13h7.814a30.445,30.445,0,0,0-1.368-8.057,30.426,30.426,0,0,1-6.447.926Zm0,0",
  transform: "translate(-251.641 -116.905)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M8.707,277.346a32.183,32.183,0,0,1-1.45-8.67H0a18.236,18.236,0,0,0,4.241,10.675,24.706,24.706,0,0,1,4.466-2.005Zm0,0",
  transform: "translate(0 -249.483)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M335.643,418.227a24.491,24.491,0,0,1-1.158,2.462,17.616,17.616,0,0,1-2.25,3.277,18.332,18.332,0,0,0,7.084-4.142A22.923,22.923,0,0,0,335.643,418.227Zm0,0",
  transform: "translate(-308.501 -388.351)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M84.273,418.227a22.91,22.91,0,0,0-3.675,1.6,18.328,18.328,0,0,0,7.084,4.142,17.658,17.658,0,0,1-2.251-3.277A24.381,24.381,0,0,1,84.273,418.227Zm0,0",
  transform: "translate(-74.84 -388.351)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M390.121,91.254a32.183,32.183,0,0,1,1.45,8.67h7.256a18.235,18.235,0,0,0-4.241-10.675,24.7,24.7,0,0,1-4.466,2Zm0,0",
  transform: "translate(-362.252 -82.874)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M390.121,277.345a24.7,24.7,0,0,1,4.466,2,18.236,18.236,0,0,0,4.241-10.675h-7.256a32.181,32.181,0,0,1-1.45,8.67Zm0,0",
  transform: "translate(-362.252 -249.483)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M271,0V7.775a28.314,28.314,0,0,0,5.711-.8,21.584,21.584,0,0,0-.969-2.044C274.344,2.352,272.607.572,271,0Zm0,0",
  transform: "translate(-251.641 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M8.707,91.255a24.7,24.7,0,0,1-4.466-2A18.234,18.234,0,0,0,0,99.924H7.256a32.182,32.182,0,0,1,1.45-8.67Zm0,0",
  transform: "translate(0 -82.874)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_33",
  "data-name": "Path 33",
  d: "M84.269,14.535a24.465,24.465,0,0,1,1.158-2.461A17.612,17.612,0,0,1,87.678,8.8a18.331,18.331,0,0,0-7.084,4.142,22.928,22.928,0,0,0,3.676,1.6Zm0,0",
  transform: "translate(-74.836 -8.169)",
  fill: "#fff"
}));

function SvgGlobal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.575,
    height: 36.243,
    viewBox: "0 0 36.575 36.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.94d99d01.svg";
export { ForwardRef as ReactComponent };